import axios from '@/lib/axios';
import { TerminateRequestParams } from '../types';

const confirmTerminate = (data: TerminateRequestParams, custCode: string | undefined) => {
  return axios.post(`/facility/flat_rates/terminate_cancels/${custCode}/terminate_confirm`, data);
}

export default confirmTerminate;